
import axiosInstance from '../services/AxiosInstance';

const API_URL = 'accountcodes'; // Replace with your actual API base URL

const AccountCodeService = {
    list: () => axiosInstance.get(`${API_URL}`),
    getAdd: () => axiosInstance.get(`${API_URL}/add`),
    add: (data) => axiosInstance.post(`${API_URL}/add`, data),
    edit: (id) => axiosInstance.get(`${API_URL}/edit/${id}`),
    update: (data) => axiosInstance.post(`${API_URL}/update`, data),
    view: (id) => axiosInstance.get(`${API_URL}/view/${id}`),
    delete: (data) => axiosInstance.post(`${API_URL}/delete`, data),
};

export default AccountCodeService;
